<template>
  <v-radio
    class="zoox-component zoox-radio"
    on-icon="$radio_button_checked_rounded"
    off-icon="$radio_button_unchecked_rounded"
    :value="value"
    :color="color"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:label>
      <slot name="content">
        <label v-if="!icon && !description">{{ label }}</label>
        <template v-else>
          <div class="label-content">
            <!--@slot Slot que define o ícone a ser usado no componente -->
            <slot name="icon">
              <z-icon v-if="icon" class="mr-1">{{ icon }}</z-icon>
            </slot>
            <div>
              <div>{{ label }}</div>
              <div v-if="description">{{ description }}</div>
            </div>
          </div>
        </template>
      </slot>
    </template>
  </v-radio>
</template>

<script>
/**
 * @displayName Radio
 */
export default {
  name: 'ZRadio',
  props: {
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    value: {
      type: [Boolean, String],
    },
    description: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-radio {
  .label-content {
    display: flex;
  }
}
</style>
